import {
    UPDATEUSERWITHDRWALCOUNT_SUCCESS,
    UPDATEUSERWITHDRWALCOUNT_FAILED,
    RESET_UPDATEUSERWITHDRWALCOUNT,
    LOADING_UPDATEUSERWITHDRWALCOUNT,
    NETWORK_ERROR_UPDATEUSERWITHDRWALCOUNT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateUserWithdrawalcount = () => {
    return { type: RESET_UPDATEUSERWITHDRWALCOUNT };
};

const updateUserWithdrawalcount = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEUSERWITHDRWALCOUNT });
    await partnerServices
        .post("updateUserWithDrawalCount", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(updateUserWithdrawalcountsuccess(res.data));
                    break;
                default:
                    dispatch(updateUserWithdrawalcountFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_UPDATEUSERWITHDRWALCOUNT, payload: err });
        });
};
function updateUserWithdrawalcountsuccess(data) {
    return {
        type: UPDATEUSERWITHDRWALCOUNT_SUCCESS,
        payload: data,
    };
}
function updateUserWithdrawalcountFailed(data) {
    return {
        type: UPDATEUSERWITHDRWALCOUNT_FAILED,
        payload: data,
    };
}

export { resetUpdateUserWithdrawalcount, updateUserWithdrawalcount };
